import { ReactNode } from "react"

export default function TableBodyCell({
    children,
    isSticky,
    isShadowShown,
    alignment,
    expandComp,
    checkboxComp,
    moleculeHighlightingComp,
    fixedItemHeight
}: {
    children: ReactNode,
    isSticky: boolean,
    isShadowShown: boolean,
    alignment: 'left' | 'center',
    expandComp?: ReactNode,
    checkboxComp?: ReactNode,
    moleculeHighlightingComp?: ReactNode,
    fixedItemHeight?: number,
}) {
    return (
        <td 
            style={{ height: fixedItemHeight ? fixedItemHeight : 'auto' }}
            className={`transition-all min-w-[200px] ${isSticky ? 'sticky left-0 bg-inherit z-10' : ''} ${isShadowShown ? 'shadow-left' : ''}`}
        >
            <div className={`flex ${alignment === 'left' ? 'justify-start' : 'justify-center'} items-center gap-2 p-6`}>
                {expandComp && (
                    <div className='mr-1 flex justify-center items-center'>{expandComp}</div>
                )}
                {checkboxComp && (
                    <div className='mr-4 flex justify-center items-center'>{checkboxComp}</div>
                )}
                {moleculeHighlightingComp && (
                    <div className='mr-4'>{moleculeHighlightingComp}</div>
                )}
                {children}
            </div>
        </td>
    )
}